import React from 'react'
import { connect } from 'react-redux'
import { updateUiAction } from 'actions/uiActions'
import injectSheet from 'react-jss'
import style from './style'
import { updateProjectSelector } from 'selectors'
import compressProject from 'helpers/projects/compressProject'
import axios from 'api/config'
import Clipboard from 'clipboard'

class Permalink extends React.Component {
  constructor(props) {
    super(props)
    this.updateState = this.updateState.bind(this)
    this.state = { key: null, copyButtonText: 'Copy' }
  }

  componentDidMount() {
    this.createPermalink()
  }

  componentDidUpdate() {
    if (this.state.key) new Clipboard(`.${this.props.classes.copyButton}`)
  }

  updateState(o) { this.setState(o) }

  createPermalink() {
    const { updateState } = this
    const project = compressProject(updateProjectSelector(this.props.state))
    axios.post('calculator_permalinks', { project }).then(({ data: { key } }) => updateState({ key }))
  }

  updateButtonTextAndCloseModal(closeModal) {
    this.setState({ copyButtonText: 'URL copied!' })
    setTimeout(closeModal, 1500)
  }

  render() {
    const { updateButtonTextAndCloseModal, state: { key, copyButtonText }, props: { updateUiAction, classes } } = this
    return (
      <div>
        {
          key
          ? <a ref='permalink' className={classes.permalink} href={`${IPVM_URL}/calculator/${key}`}>{`${IPVM_URL}/calculator/${key}`}</a>
          : 'Creating Permalink...'
        }
        { key &&
          <button
            onClick={updateButtonTextAndCloseModal.bind(this, updateUiAction.bind(null, { modal: null }))}
            className={classes.copyButton}
            data-clipboard-target={`.${classes.permalink}`}
          >
            {copyButtonText}
          </button>}
      </div>
    )
  }
}

export const PermalinkConfig = { title: 'Permalink' }
export default connect(state => ({ state }), { updateUiAction })(injectSheet(style)(Permalink))



// WEBPACK FOOTER //
// ./src/components/Permalink/index.js